import mark from "./brand-mark.jpg";
import styles from "./brand-mark.module.css";

/**
 * The product's mark: Sortera's circular arrows as a lake in a forest, cropped to a disc — a nod
 * to the "circular partner", without borrowing the Sortera logo, which belongs to the brand team.
 */
export function BrandMark({ size = "md", showName = true }: { size?: "md" | "lg"; showName?: boolean }) {
  return (
    <span className={`${styles.mark} ${size === "lg" ? styles.large : ""}`}>
      <img className={styles.icon} src={mark} alt="" aria-hidden draggable={false} />
      {showName && (
        <span className={styles.name}>
          Sortera <span className={styles.accent}>Factory</span>
        </span>
      )}
    </span>
  );
}
